(function($){
  'use strict';

  if(!$.tangible){
    $.tangible = new Object();
  };

  $.tangible.formFlights = function(el, options){
    var base = this;

    base.$el = $(el);
    base.el = el;

    base.init = function(){

      base.$btnPax = $('.js-toggleFlightsPax');
      base.$btnClosePaxCnt = $('.js-closeFlightsPax');
      base.$paxCnt = $('.js-flightsPaxCnt');

      // Variables for c-form--flights-edit
      base.$flightEditInputs = $('.c-form--flights-edit input');
      base.$flightEditSelects = $('.c-form--flights-edit select');
      base.$flightEditInputsArray = $('.c-form--flights-edit input').toArray();
      base.$flightSwitchButton = $('.c-form--flights-edit .js-switch-btn');
      base.$flightEditButtonEdit = $('.c-form--flights-edit .js-flight-btn-edit');
      base.$flightEditButtonConfirm = $('.c-form--flights-edit .js-flight-btn-confirm-modifies');
      base.$overlay = $('.o-spotlight__element');
      base.$closeOverlayBtn = $('.js-close-overlay');

      // Opens the box of passengers
      base.$btnPax.click(function(e){
        e.preventDefault();
        base.$paxCnt.toggleClass('is-visible');
        // Switches the state of aria-expanded
        var expanded = $(this).attr('aria-expanded') === 'true' || false;
        $(this).attr('aria-expanded', !expanded);
        
        // if( $( window ).width() < 768 ) {
        //   // Scroll to element
        //   $('html, body').animate({
        //     scrollTop: base.$paxCnt.offset().top
        //   }, 800);
        // }
        
      });
      
      // Closes the box of passengers
      base.$btnClosePaxCnt.click(function(e){
        e.preventDefault();
        base.$paxCnt.removeClass('is-visible');
        // Set the state of aria-expanded to false
        base.$btnPax.attr('aria-expanded', false);
      });

      // Adds Readonly attribute on c-form--flights-edit inputs
      base.addsReadonly();
      
      // Calls functions when flightEditButtonEdit is pressed
      base.$flightEditButtonEdit.click(function(e){
        e.preventDefault();
        base.removesReadonly();
        base.setFocusOnFirstInput();
        base.showEditButtonConfirm($(this));
        base.showSwitchButton($(this));
        base.addsOverlay();
      });

      base.$closeOverlayBtn.click(function(e){
        e.preventDefault();
        base.removesOverlay( $(this) );
        base.addsReadonly();
        base.$flightEditButtonEdit.show();
        base.$flightEditButtonConfirm.hide();
        //base.$flightSwitchButton.hide();
      });

      $( window ).resize(function() {
        base.checkWindowSize();
      });
      
    };

    ///////// FUNCTIONS FOR C-FORM--FLIGHTS-EDIT /////////

      // Adds readonly
      base.addsReadonly = function() {
        base.$flightEditInputs.prop('readonly', true);
        base.$flightEditInputs.prop('disabled', true);
        base.$flightEditSelects.prop('readonly', true);
        base.$flightEditSelects.prop('disabled', true);
        $('.c-form--flights-edit .js-toggleFlightsPax').prop('disabled', true);
        base.$flightEditInputs.parent('label').addClass("is-readonly");
      }

      // Removes readonly
      base.removesReadonly = function() {
        base.$flightEditInputs.prop('readonly', false);
        base.$flightEditInputs.prop('disabled', false);
        base.$flightEditSelects.prop('readonly', false);
        base.$flightEditSelects.prop('disabled', false);
        $('.c-form--flights-edit .js-toggleFlightsPax').prop('disabled', false);
        base.$flightEditInputs.parent().removeClass("is-readonly");
      }

      // Set focus on first input
      base.setFocusOnFirstInput = function() {
        base.$flightEditInputsArray[0].focus();
      }

      // Change button properties
      base.showEditButtonConfirm = function(el) {
        el.hide();
        base.$flightEditButtonConfirm.css('display', 'block');
      }
    
      // Change Switch button properties
      base.showSwitchButton = function(el) {
        el.hide();
       // base.$flightSwitchButton.css('display', 'flex');
      }

      // Adds overlay
      base.addsOverlay = function() {
        base.$overlay.addClass('o-spotlight__element--overlay');
        base.$overlay.closest('.o-spotlight').addClass('is-active');
        base.$closeOverlayBtn.show();
      }

      // Removes overlay
      base.removesOverlay = function(elem) {
        base.$overlay.removeClass('o-spotlight__element--overlay');
        base.$overlay.closest('.o-spotlight').removeClass('is-active');
        elem.hide();
      }

      base.checkWindowSize = function() {
        if( $( window ).width() < 1024 ) {
          base.$flightEditButtonEdit.text('Modifica la ricerca');
        } else {
          base.$flightEditButtonEdit.text('Modifica');
        }
      }
    
    ///////// END FUNCTIONS FOR C-FORM--FLIGHTS-EDIT /////////

    base.init();
    base.checkWindowSize();

  };

  $.fn.tangible_formFlights = function(options){
    return this.each(function(){
      (new $.tangible.formFlights(this, options));
    });
  };

})(jQuery);

